import Navigation from "@/components/Navigation";
import Footer from "@/components/Footer";
import Hero from "@/components/home/Hero";
import LearningGrid from "@/components/home/LearningGrid";
import VideoSection from "@/components/home/VideoSection";
import SpellingOfTheDay from "@/components/home/SpellingOfTheDay";
import SentenceOfTheDay from "@/components/home/SentenceOfTheDay";
import DailyTip from "@/components/home/DailyTip";
import AnimalFacts from "@/components/home/AnimalFacts";
import ParentsSection from "@/components/home/ParentsSection";
import ParentTrust from "@/components/home/ParentTrust";
import PlanPreview from "@/components/home/PlanPreview";
import HomeBlogs from "@/components/home/HomeBlogs";
import LearningJourney from "@/components/home/LearningJourney";
import PremiumBenefits from "@/components/home/PremiumBenefits";
import PlatformStats from "@/components/home/PlatformStats";
import DailyChallenge from "@/components/home/DailyChallenge";
import StoryOfTheWeek from "@/components/home/StoryOfTheWeek";
import PrintableFriday from "@/components/home/PrintableFriday";
import WeeklyQuizBadge from "@/components/home/WeeklyQuizBadge";
import ComprehensiveSEO from "@/components/ComprehensiveSEO";
import SeoContentSection from "@/components/seo/SeoContentSection";
import EducationalSchema from "@/components/seo/EducationalSchema";
import LeoMascot from "@/components/shared/LeoMascot";

import animalFriends from "@/assets/animal-friends.png";

const Index = () => {
  return (
    <div className="flex flex-col min-h-screen">
      <ComprehensiveSEO
        title="TinyMinds - Fun Learning Platform for Kids Ages 3-8"
        description="Watch fun and educational videos for kids ages 3–8. Safe, engaging learning content covering alphabets, numbers, science, stories, and more on TinyMinds."
        canonicalUrl="https://tinyminds.in"
      />

      <Navigation />
      <main className="flex-grow relative overflow-hidden bg-cyan-50">
        {/* Subtle floating clouds */}
        <div className="absolute top-20 left-[5%] w-32 h-16 bg-white/40 rounded-full blur-md pointer-events-none" />
        <div className="absolute top-[300px] right-[10%] w-40 h-20 bg-white/30 rounded-full blur-lg pointer-events-none" />
        <div className="absolute top-[500px] left-[15%] w-28 h-14 bg-white/25 rounded-full blur-md pointer-events-none" />

        <Hero />

        {/* Video + Categories — primary focus */}
        <section className="container mx-auto px-4 py-8">
          <div className="flex flex-col md:flex-row items-center gap-8 md:gap-10">
            <div className="w-full md:w-[48%] flex justify-center">
              <VideoSection />
            </div>
            <div className="w-full md:w-[52%]">
              <LearningGrid />
            </div>
          </div>
        </section>

        {/* Logged-in user progress (compact) */}
        <LearningJourney />
        <DailyChallenge />

        {/* Premium SaaS benefits */}
        <PremiumBenefits />

        {/* Parent trust + platform stats */}
        <PlatformStats />
        <ParentTrust />

        {/* Animal friends banner */}
        <div className="flex justify-center py-2">
          <img
            src={animalFriends}
            alt="Cute animal friends - koala, lion and elephant"
            className="w-48 md:w-64 opacity-80"
          />
        </div>

        <div className="container mx-auto px-4 py-6">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
            <SpellingOfTheDay />
            <SentenceOfTheDay />
          </div>
        </div>
        <StoryOfTheWeek />
        <PrintableFriday />
        <WeeklyQuizBadge />
        <DailyTip />
        <AnimalFacts />
        <ParentsSection />
        <HomeBlogs />
        <PlanPreview />
        <EducationalSchema
          name="TinyMinds — Early Learning App for Kids in India"
          description="India-made early learning platform for ages 3–8: phonics, math, science, stories, rhymes, worksheets and brain-development activities for preschool, LKG, UKG and early primary."
          about={[
            "Preschool learning India",
            "Kindergarten activities",
            "LKG UKG worksheets",
            "Phonics for kids",
            "Moral stories for kids",
            "Nursery rhymes",
            "Brain development for toddlers",
          ]}
          resourceType="LearningResource"
        />
        <SeoContentSection path="/" />
      </main>
      <LeoMascot pose="wave" size="md" position="bottom-right" animation="float" />
      <Footer />
    </div>
  );
};

export default Index;
